import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';
import ProductBrand from '../../models/ProductBrand';


export interface ProductBrandDetailState extends ApiState {
  productBrand?: ProductBrand
}

export default requestReducer<ProductBrandDetailState>('PRODUCTBRAND_DETAIL')
